import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { EmailAlertService } from '@suvo-bi-lib';
import { ProductService } from '@suvo-bi-users';

@Component({
  standalone: false,
  selector: 'app-email-alerts-button',
  templateUrl: './email-alerts-button.component.html',
  styleUrls: ['./email-alerts-button.component.scss'],
})
export class EmailAlertsButtonComponent implements OnInit {
  @Input('filterGroup') filterGroup: string;

  loading = true;

  alertsEnabled = false;

  currentTenantData;

  emailsAllowed = false;

  constructor(
    private router: Router,
    private productService: ProductService,
    private emailAlertService: EmailAlertService,
  ) {}

  async ngOnInit() {
    this.emailsAllowed = this.productService.isFeatureEnabled('EMAIL_ALERTS', [
      'DATASOURCE:' + this.filterGroup,
    ]);

    if (this.emailsAllowed) {
      const existingSelectedFilter = await this.emailAlertService.getSelectedEmailFilter(
        this.filterGroup,
      );

      if (existingSelectedFilter) {
        this.alertsEnabled = true;
      } else {
        this.alertsEnabled = false;
      }
    }

    this.loading = false;
  }

  onClick() {
    this.router.navigate([`/private/${this.filterGroup}/email-alerts`]);
  }
}
